import type { LegacyReport } from '@mathflat/domain/Report'
import type { Revision } from '@mathflat/domain/SchoolSystem'
import { makeObservable, observable } from 'mobx'
import { EMPTY_NUMBER_ID, EMPTY_STRING_ID } from 'src/constant/common'

import dateUtils from '@/utils/DateUtils'

import { DTO } from '../DTO'

export type SimpleReportData = Omit<LegacyReport, 'worksheetTagFlags' | 'selfLearningFlag'> & {
  learningHistory: {
    worksheetTagFlags: LegacyReport['worksheetTagFlags']
    selfLearningFlag: LegacyReport['selfLearningFlag']
  }
}

export class SimpleReport extends DTO implements SimpleReportData {
  static COMPONENT_LIST = [
    { label: '주별 분석', value: 'WEEKLY' },
    { label: '단원별 분석', value: 'CHAPTER_SUMMARY' },
    { label: '난이도별 분석', value: 'LEVEL' },
    { label: '단원별 세부 페이지', value: 'CHAPTER_DETAIL' },
    { label: '학습 내역', value: 'STUDY_HISTORY' },
    { label: '영역별 분석 (내용 영역·행동 영역)', value: 'ASSESSMENT' },
  ] as const

  id = EMPTY_NUMBER_ID
  studentId = EMPTY_STRING_ID
  comment = EMPTY_STRING_ID
  pdfUrl = EMPTY_STRING_ID
  chapter = EMPTY_STRING_ID
  areaScore = EMPTY_NUMBER_ID
  behaviorScore = EMPTY_NUMBER_ID
  totalScore = EMPTY_NUMBER_ID
  totalTier = EMPTY_NUMBER_ID
  createDatetime = EMPTY_STRING_ID
  studentName = EMPTY_STRING_ID
  type: 'MONTHLY' | 'CUSTOM_PERIOD' = 'MONTHLY'
  yearMonth: SimpleReportData['yearMonth'] = dateUtils.toYearMonth(new Date(), '-')
  startDate = dateUtils.toDateString(new Date(), '-')
  endDate = dateUtils.toDateString(new Date(), '-')
  title = EMPTY_STRING_ID
  extraScore = EMPTY_NUMBER_ID
  learningHistory: SimpleReportData['learningHistory'] = {
    worksheetTagFlags: [],
    selfLearningFlag: false,
  }

  componentFlags: SimpleReportData['componentFlags'] = []
  opened = false
  deleted = false
  sending = false
  status: SimpleReportData['status'] = 'GENERATING'
  revision: Revision = 'CURRICULUM_15'

  constructor(data: Partial<LegacyReport>) {
    super()
    makeObservable(this, {
      id: observable,
      studentId: observable,
      comment: observable,
      pdfUrl: observable,
      chapter: observable,
      areaScore: observable,
      behaviorScore: observable,
      totalScore: observable,
      totalTier: observable,
      createDatetime: observable,
      studentName: observable,
      type: observable,
      yearMonth: observable,
      startDate: observable,
      endDate: observable,
      title: observable,
      extraScore: observable,
      learningHistory: observable,
      componentFlags: observable,
      opened: observable,
      sending: observable,
      deleted: observable,
      status: observable,
    })

    this.update<SimpleReportData>({
      ...data,
      learningHistory: {
        worksheetTagFlags: data.worksheetTagFlags ?? [],
        selfLearningFlag: data.selfLearningFlag ?? false,
      },
    })
  }
}
